import { defineMessages } from 'react-intl';

export const scope = 'app.lib.services.user';

export const messages = defineMessages({
  errSettingsNotSaved: {
    id: `${scope}.errSettingsNotSaved`,
    defaultMessage: "Your change couldn't be saved, so it was put back. Please try again.",
  },
});
